let map: google.maps.Map;

export async function initMap(infoWindowId: string | null | undefined = null): Promise<void> {
    try {
        const mapElements = document.querySelectorAll('.js-community-map') as NodeListOf<HTMLElement>;

        if (!mapElements.length) {
            console.warn('No map elements detected');
            return;
        }

        const position = { lat: 48.0365, lng: -122.1132 };

        const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;

        // Loop through each map element and initialize a map
        mapElements.forEach((mapElement) => {
            const map = new Map(mapElement, {
                zoom: 16,
                center: position,
                mapId: 'js-community-map',
                disableDefaultUI: true,
            });

            const circle = document.createElement('div');
            circle.className = 'circle-map-marker';
            circle.textContent = '';

            const marker = new AdvancedMarkerElement({
                map: map,
                position: position,
                title: 'Redstone at Whiskey Ridge',
                content: circle,
            });

            if (infoWindowId) {
                const infoWindow = document.getElementById(infoWindowId);

                if (infoWindow) {
                    infoWindow?.classList.toggle('active');
                }                
            }
        });
    } catch (error) {
        console.error('Failed to initialize maps:', error);
    }
}
